import { retry, catchError } from 'rxjs/operators';
import { UtilsService } from '../../../utils/utils';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class CadastroColaboradorEmpregadorService {

    routePrefix: string = 'ColaboradorEmpregador'
    constructor(
        private httpClient: HttpClient,
        private utilsService: UtilsService,
    ) { }

    pesquisar(data = {}): Observable<any> {
        return this.httpClient.post<Array<any>>(`${environment.urlBase}${this.routePrefix}/BuscarEmpregadorColaborador`, data)
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }
    pesquisarPorUsuarioId(data = {}, usuarioId): Observable<any> {
      return this.httpClient.post<Array<any>>(`${environment.urlBase}${this.routePrefix}/BuscarEmpregadorColaboradorPorUsuarioId?usuarioId=${usuarioId}`, data)
          .pipe(
              retry(1),
              catchError(this.utilsService.handleError));
  }

    pesquisarPreAdmissao(data: any = {}): Observable<any> {
        return this.httpClient.post<Array<any>>(`${environment.urlBase}${this.routePrefix}/BuscarEmpregadorColaboradorPreAdmissao`, data)
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }
    pesquisarPreAdmissaoPorUsuarioId(data: any = {}, usuarioId: number): Observable<any> {
      return this.httpClient.post<Array<any>>(`${environment.urlBase}${this.routePrefix}/BuscarEmpregadorColaboradorPreAdmissaoPorUsuarioId?usuarioId=${usuarioId}`, data)
          .pipe(
              retry(1),
              catchError(this.utilsService.handleError));
  }

    adicionar(data = {},concluir?:boolean): Observable<any> {
      console.log(concluir);
        return this.httpClient.post<any>(`${environment.urlBase}${this.routePrefix}/AdicionarEmpregadorColaborador?concluir=${concluir}`, data)
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }

    editar(data = {},concluir?:boolean): Observable<any> {
      console.log(concluir);
        return this.httpClient.post<any>(`${environment.urlBase}${this.routePrefix}/EditarEmpregadorColaborador?concluir=${concluir}`, data)
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }

    remover(data): Observable<any> {
        return this.httpClient.post<any>(`${environment.urlBase}${this.routePrefix}/ExcluirEmpregadorColaborador?id=${data.id}`, {})
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }

    pesquisarEmpregador(): Observable<any> {
        return this.httpClient.get<Array<any>>(`${environment.urlBase}${this.routePrefix}/BuscarTudoEmpregadorColaborador`, {})
            .pipe(
                retry(1),
                catchError(this.utilsService.handleError));
    }
}
